import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Utility cn() per combinare classi Tailwind senza conflitti
// Compatibile con shadcn/ui e CVA
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
